import React from 'react';
import { cn } from '@/lib/utils';
import { Input } from '../ui/input';

type InputFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  id?: string;
  extra?: string;
  placeholder?: string;
  name?: string;
  inputClass?: string;
  title?: string;
  rows?: number;
  errorMessage?: {
    message: string;
  };
  register?: any;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: any;
};

const DMInput = ({
  label,
  id,
  extra = '',
  type = 'text',
  placeholder,
  disabled = false,
  inputClass,
  inputMode = 'text',
  title,
  rows = 3,
  errorMessage,
  register,
  onChange,
  name,
  onBlur,
  value,
}: InputFieldProps) => {
  return (
    <div className={extra}>
      <div className='flex justify-between mb-1'>
        {label && (
          <label
            htmlFor={id}
            className='text-sm text-brand-primary-text ml-1 font-medium flex-1 w-full'
          >
            {label}
          </label>
        )}
      </div>
      {type === 'textarea' ? (
        <textarea
          disabled={disabled}
          id={id}
          rows={rows}
          placeholder={placeholder}
          className={cn(
            'flex w-full items-center justify-center rounded-md !bg-brand-secondary p-3 outline-none text-sm border-none',
            inputClass,
            disabled &&
              '!border !border-slate-400 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]'
          )}
          name={name}
          onChange={onChange}
          {...register}
        />
      ) : (
        <Input
          disabled={disabled}
          type={type}
          id={id}
          placeholder={placeholder}
          inputMode={inputMode}
          title={title}
          className={cn(
            'flex h-12 w-full items-center justify-center rounded-md !bg-brand-secondary p-3 outline-none text-sm border-none',
            inputClass,
            disabled &&
              '!border !border-slate-400 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]'
          )}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          {...register}
          tabIndex='-1'
        />
      )}
      {errorMessage?.message && (
        <p className='text-red-400 text-[11px]'>
          {errorMessage?.message?.toLowerCase()?.includes('invalid')
            ? 'Field is required'
            : errorMessage?.message}
        </p>
      )}
    </div>
  );
};

export default DMInput;
